"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _UITether = _interopRequireDefault(require("UITether/UITether"));

var _ActionButtons = _interopRequireDefault(require("./ActionButtons"));

var _utils = require("composer-plugins/lib/utils");

var ACTION_BUTTONS_CLASSNAME = 'question-and-answer-content-component-options';
var OFFSET_VERTICAL = 15;
var OFFSET_HORIZONTAL = -OFFSET_VERTICAL;
var QUESTION_AND_ANSWER_CLASS = 'question-and-answer-content';

function shouldEventHideActionButtons(event) {
  var target = event.toElement || event.relatedTarget;
  var isContainedByOptionMenu = (0, _utils.targetIsOrContainedByEl)("." + ACTION_BUTTONS_CLASSNAME, target);
  var isContainedByTile = (0, _utils.targetIsOrContainedByEl)("." + QUESTION_AND_ANSWER_CLASS, target);

  if (isContainedByOptionMenu || isContainedByTile) {
    return false;
  }

  return true;
}

var ActionButtonsProvider = function ActionButtonsProvider(_ref) {
  var children = _ref.children,
      onEditClicked = _ref.onEditClicked,
      onDeleteClicked = _ref.onDeleteClicked,
      disabled = _ref.disabled,
      hideEditButton = _ref.hideEditButton;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var child = _react.default.Children.only(children);

  if (disabled) {
    return child;
  }

  var onMouseLeave = function onMouseLeave(event) {
    if (shouldEventHideActionButtons(event)) {
      setOpen(false);
    }
  };

  var childWithListeners = _react.default.cloneElement(child, {
    onMouseEnter: function onMouseEnter() {
      return setOpen(true);
    },
    onMouseLeave: onMouseLeave
  });

  return _react.default.createElement(_UITether.default, {
    classPrefix: "compose-draft-question-and-answer-content-action-buttons",
    attachmentHoriz: "right",
    attachmentVert: "top",
    targetAttachmentHoriz: "right",
    targetAttachmentVert: "top",
    content: _react.default.createElement(_ActionButtons.default, {
      open: open,
      className: ACTION_BUTTONS_CLASSNAME,
      onMouseLeave: onMouseLeave,
      onEditClicked: onEditClicked,
      onDeleteClicked: onDeleteClicked,
      hideEditButton: hideEditButton
    }),
    constraints: [{
      to: 'scrollParent',
      pin: ['right']
    }],
    offsetVert: OFFSET_VERTICAL,
    offsetHoriz: OFFSET_HORIZONTAL
  }, childWithListeners);
};

ActionButtonsProvider.propTypes = {
  disabled: _react.PropTypes.bool.isRequired,
  onEditClicked: _react.PropTypes.func,
  onDeleteClicked: _react.PropTypes.func.isRequired,
  children: _react.PropTypes.node.isRequired,
  hideEditButton: _react.PropTypes.bool
};
ActionButtonsProvider.defaultProps = {
  hideEditButton: false
};
var _default = ActionButtonsProvider;
exports.default = _default;
module.exports = exports.default;